import { createAction, handleActions, Reducer } from 'redux-actions';

interface App {
  id?: string;
}

export interface AppState {
  isLoading: boolean;
  appList: App[];
  searchTerm: string;
}

export const initialState: AppState = {
  isLoading: false,
  appList: [],
  searchTerm: '',
};

type AppReducer<T = AppState> = Reducer<AppState, T>;

// Actions

const APP_LIST_FETCH_STARTED = 'app/APP_LIST_FETCH_STARTED';
const APP_LIST_FETCH_SUCCEED = 'app/APP_LIST_FETCH_SUCCEED';
const APP_LIST_FETCH_FAILED = 'app/APP_LIST_FETCH_FAILED';
const APP_SEARCH = 'app/APP_SEARCH';

// Action creators

export const fetchAppList = createAction(APP_LIST_FETCH_STARTED);
export const fetchAppListSucceed = createAction(APP_LIST_FETCH_SUCCEED);
export const fetchAppListFailed = createAction(APP_LIST_FETCH_FAILED);
export const searchAppList = createAction(APP_SEARCH);

// Reducers

const handleFetchAppList: AppReducer = state => ({
  ...state,
  isLoading: true,
});

const handleFetchAppListSucceed: AppReducer<App[]> = (state, { payload }) => ({
  ...state,
  isLoading: false,
  appList: payload,
});

const handleSearchApp: AppReducer<string> = (state, { payload }) => ({
  ...state,
  searchTerm: payload || '',
});

export default handleActions<AppState, any>(
  {
    [APP_LIST_FETCH_STARTED]: handleFetchAppList,
    [APP_LIST_FETCH_SUCCEED]: handleFetchAppListSucceed,
    [APP_SEARCH]: handleSearchApp,
  },
  initialState,
);

// Selectors

export const getAppState = (state): AppState => state.app;
